export default {
      id: "tedx-usage",
      viewBox: "0 0 117 36",
      url: __webpack_public_path__ + "sprite.svg#tedx",
      toString: function () {
        return this.url;
      }
    }